import { render, staticRenderFns } from "./Historical.vue?vue&type=template&id=3cc465c7&"
import script from "./Historical.vue?vue&type=script&lang=ts&"
export * from "./Historical.vue?vue&type=script&lang=ts&"
import style0 from "./Historical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports